import { render, staticRenderFns } from "./teacher-eva.vue?vue&type=template&id=5df5860c&scoped=true&"
import script from "./teacher-eva.vue?vue&type=script&lang=js&"
export * from "./teacher-eva.vue?vue&type=script&lang=js&"
import style0 from "./teacher-eva.vue?vue&type=style&index=0&id=5df5860c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df5860c",
  null
  
)

export default component.exports